import { apiClient } from '../config/api';

export interface FeatureFlags {
  create_account_enabled: boolean;
}

class FeatureFlagsService {
  async getFeatureFlags(): Promise<FeatureFlags> {
    const response = await apiClient.get<{
      success: boolean;
      data: FeatureFlags;
      timestamp: string;
    }>('/features');

    return response.data.data;
  }

  async updateFeatureFlags(flags: FeatureFlags): Promise<FeatureFlags> {
    const response = await apiClient.put<{
      success: boolean;
      data: FeatureFlags;
      message: string;
      timestamp: string;
    }>('/features', flags);

    return response.data.data;
  }
}

export const featureFlagsService = new FeatureFlagsService();
